<div class="view areas">

  <!-- Header-->
  <div class="header">

    <div class="header-title">
      <span>
        <h1>Ruimtestaat: {{ building.name }}</h1>
      </span>

      <!-- Toolbar -->
      <span class="toolbar">
        <button mat-flat-button color="primary" (click)="addCluster()" [disabled]="onDragCluster">
          {{ 'addcluster' | translate }}
        </button>
        <ng-container [ngSwitch]="onDragCluster">
          <button *ngSwitchCase="false" mat-flat-button color="primary" (click)="enableDragCluster()" 
            [disabled]="clusters.length < 2">
            Clusters sorteren
          </button>
          <button *ngSwitchCase="true" mat-flat-button color="primary" (click)="disableDragCluster()">
            Klaar met sorteren
          </button>
        </ng-container>
        <sg2-building-options 
          [building]="building"
          [options]="['setRatioAs', 'setRatioBy']"
          (action)="enableDragCluster()">
        </sg2-building-options>
      </span>

    </div>

    <!-- Header: Content area -->
    <div class="header-content">
      <sg2-building-info-ratio [building]="building"></sg2-building-info-ratio>
    </div>
  
  </div>
  
  <!-- View -->
  <div cdkDropList 
    class="view-content"
    [ngClass]="{ 'on-drag-cluster': onDragCluster }"
    cdkDropListLockAxis="y"
    [cdkDropListData]="clusters"
    (cdkDropListDropped)="onDropCluster($event)">

    <!-- Cluster -->
    <div cdkDrag *ngFor="let cluster of clusters"
      class="cluster"
      [id]="cluster._id"
      [cdkDragData]="cluster">

      <mat-card>
        <mat-card-header [style.backgroundColor]="cluster.color">
          <span class="title">
            <h3>
              <span cdkDragHandle class="handle handle-cluster">
                <mat-icon>drag_indicator</mat-icon>
              </span>
              Cluster: {{ cluster.name }} ({{ cluster.shortCode }})
            </h3>
          </span>

          <!-- Toolbar -->
          <span class="toolbar">
            <button mat-flat-button
              color="primary" 
              (click)="addArea(cluster)"
              [disabled]="onDragCluster">
              {{ 'addarea' | translate }}
            </button>
            <sg2-cluster-options
              *ngIf="authService.canUpdate('cluster')"
              [cluster]="cluster"
              [options]="['addArea', 'color', 'delete', 'edit']"
              [disabled]="onDragCluster">
            </sg2-cluster-options>
          </span>

        </mat-card-header>
        
        <hr>
        
        <mat-card-content>
          
          <!-- Sub-cluster -->
          <!-- <div class="sub-content">
            <div fxLayout="row">
              <h4 fxFlex="50">Subcluster: Algemeen</h4>
              <span class="toolbar" fxFlex="50">
                <button mat-flat-button color="primary">Ruimte toevoegen</button>
              </span>
            </div>
          </div> -->

          <!-- BVO/FNO ratio for clusters. Element is hidden during cluster dragging. -->
          <ng-container *ngIf="!onDragCluster">
            <sg2-cluster-info-ratio [cluster]="cluster"></sg2-cluster-info-ratio>
            <hr>
          </ng-container>

          <!-- Areas table container. Table is hidden during cluster draggin. -->
          <ng-container *ngIf="!onDragCluster else totalAreas">

            <!-- Areas table. When the cluster has no areas, a message is shown. -->
            <table mat-table cdkDropList 
              class="table-fixed table-rows-clickable"
              *ngIf="cluster.areas.length else noAreas"
              cdkDropListLockAxis="y"
              [id]="'table-' + cluster._id"
              [dataSource]="cluster.areas"
              [cdkDropListConnectedTo]="dropListIds"
              [cdkDropListData]="cluster.areas"
              (cdkDropListDropped)="onDropArea($event)">

              <!-- Code -->
              <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef ngClass="has-drag-handle">{{ 'code' | translate }}</th>
                <td mat-cell *matCellDef="let area; let i = index">
                  <span cdkDragHandle class="handle"><mat-icon>drag_indicator</mat-icon></span>
                  {{ cluster.shortCode }}-{{ i + 1 }}
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>

              <!-- Name -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>{{ 'name' | translate }}</th>
                <td mat-cell *matCellDef="let area" ngClass="text-drag-bold">
                  <span class="text-ellipsis-2">{{ area.name }}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>

              <!-- Area template -->
              <ng-container matColumnDef="template">
                <th mat-header-cell *matHeaderCellDef>{{ 'areatemplate' | translate }}</th>
                <td mat-cell *matCellDef="let area">
                  <!-- <span class="text-ellipsis-2">{{ basicAreaService.getBasicArea(area.basicAreaId).name }}</span> -->
                  <span class="text-ellipsis-2">{{ area.customValues?.areaTemplateName }}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>

              <!-- Functionality -->
              <ng-container matColumnDef="functionality">
                <th mat-header-cell *matHeaderCellDef>{{ 'functionality' | translate }}</th>
                <td mat-cell ngClass="row-clickable-exclude" *matCellDef="let area">
                  <sg2-inline-edit-area-functionality [area]="area"></sg2-inline-edit-area-functionality>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>

              <!-- Quantity -->
              <ng-container matColumnDef="quantity">
                <th mat-header-cell *matHeaderCellDef>{{ 'quantity' | translate }}</th>
                <td mat-cell *matCellDef="let area" [class.muted]="!area.quantity">
                  {{ area.quantity }}
                </td>
                <td mat-footer-cell *matFooterCellDef>{{ cluster.areas | sum: 'quantity' }}</td>
              </ng-container>

              <!-- Expected occupation -->
              <ng-container matColumnDef="occupation">
                <th mat-header-cell *matHeaderCellDef>{{ 'expectedoccupation' | translate }}</th>
                <td mat-cell *matCellDef="let area" [class.muted]="!area.occupation">
                  {{ area.occupation }}
                  <span class="muted">{{ 'peopleAbbreviation' | translate: 'lowerCase' }}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>

              <!-- Minimum height -->
              <ng-container matColumnDef="height">
                <th mat-header-cell *matHeaderCellDef>{{ 'minimalheight' | translate }}</th>
                <td mat-cell *matCellDef="let area" [class.muted]="!area.height">
                  {{ area.height || 0 | number: '1.0-1' }}
                  <span class="muted">m</span>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>

              <!-- Surface -->
              <ng-container matColumnDef="surface">
                <th mat-header-cell *matHeaderCellDef>{{ 'surface' | translate }}</th>
                <td mat-cell *matCellDef="let area">
                  <span class="text-ellipsis-2" [class.muted]="!area.surface">
                    {{ area.surface }}
                    <span class="muted">m<sup>2</sup></span>
                  </span>
                </td>
                <td mat-footer-cell *matFooterCellDef [class.muted]="!(cluster.areas | sum: 'surface')">
                  {{ cluster.areas | sum: 'surface' }}
                  <span class="muted">m<sup>2</sup></span>
                </td>
              </ng-container>

              <!-- Surface total -->
              <ng-container matColumnDef="surfaceTotal">
                <th mat-header-cell *matHeaderCellDef>{{ 'surfaceTotal' | translate }}</th>
                <td mat-cell *matCellDef="let area" [class.muted]="!(area.surface * area.quantity)">
                  <span class="text-ellipsis-2">
                    {{ area.surface * area.quantity }}
                    <span class="muted">m<sup>2</sup></span>
                  </span>
                </td>
                <td mat-footer-cell *matFooterCellDef [class.muted]="!clusterSurfaceTotal[cluster._id]">
                  {{ clusterSurfaceTotal[cluster._id] }}
                  <span class="muted">m<sup>2</sup></span>
                </td>
              </ng-container>

              <!-- Options -->
              <ng-container matColumnDef="options">
                <th mat-header-cell *matHeaderCellDef>{{ 'option' | translate: 'plural' }}</th>
                <td mat-cell ngClass="row-clickable-exclude" *matCellDef="let area">
                  <sg2-area-options
                    *ngIf="authService.canUpdate('area')"
                    [area]="area"
                    [options]="['delete']">
                  </sg2-area-options>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
              <tr mat-row cdkDrag 
                *matRowDef="let row; columns: tableColumns; let area"
                ngClass="area"
                [id]="area._id"
                (click)="goToArea(area, $event)"
                [cdkDragData]="area"></tr>
              <tr mat-footer-row *matFooterRowDef="tableColumns"></tr>

            </table>
          </ng-container>

          <!-- When there are no areas, display message instead of rendering an emtpty table. -->
          <ng-template #noAreas>
            <span class="template-no-areas">
              <strong>
                {{ 'clusterhasnoareas' | translate: 'plural' }}
              </strong>
            </span>
          </ng-template>

          <!-- When in cluster drag mode, only show number of areas instead of area table. -->
          <ng-template #totalAreas>
            <span class="template-total-areas">
              <strong>
                {{ cluster.areas.length }} {{ 'area' | translate: (cluster.areas.length != 1 ? 'plural' : null) }}
              </strong>
            </span>
          </ng-template>
          
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- Footer with totals. -->
  <!-- Only show footer when there are active clusters. -->
  <div class="footer" *ngIf="clusters.length">
    <div class="footer-title">
      <h3>{{ 'total' | translate: 'plural' }}</h3>
    </div>
    <div class="footer-content">
      <sg2-cluster-totals [building]="building"></sg2-cluster-totals>
    </div>
  </div>

</div>